import {
    getHospital,
    getEnvironment,
    getConfigs,
} from '@/api/hospital'
const state = {
    hospInfo: {
        id: "",
        name: "",
        address: "",
        hospType: "",
        phones: [{
            name: "",
            phoneNumber: "",
        }],
        primaryPhone: "",
        openHour: "",
    },
    env: {
        version: '',
        imagePath: '',
    },
    configs: [],
    assets: [],
}

const mutations = {
    SET_HOSPITAL(state, data) {
        state.hospInfo = data;
    },
    SET_ENV(state, data) {
        state.env = data;
    },
    SET_CONFIGS(state, data) {
        state.configs = data;
    },
    SET_ASSETS(state, data) {
        state.assets = data;
    }
}

const actions = {
    setHosptital(store, data) {
        store.commit("SET_HOSPITAL", data); //调用mutation需要用commit方法
    },
    setAssets({
        commit
    }, data) {
        commit("SET_ASSETS", data); //调用mutation需要用commit方法
    },
    getHospitalInfo({
        commit
    }, hospId) {
        getHospital(hospId).then(res => {
            console.log(res);
            commit("SET_HOSPITAL", res.data);
        });
    },
    getEnv({
        commit
    }) {
        getEnvironment().then(res => {
            commit("SET_ENV", res);
        })
    },
    getConfigs({
        commit
    }, hospId) {
        if (!hospId) {
            hospId = localStorage.getItem("hospid");
        }
        getConfigs(hospId).then(res => {
            commit("SET_CONFIGS", res.data);
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}